import isValidCombatantReaction from "./isValidCombatantReaction";
//------------------------
// is valid reaction slot
//------------------------
export default function isValidReactionSlot(parm) {
  //---------------------------
  // invalid - future reaction
  //---------------------------
  if (parm.view_round > parm.arena_round) {
    return false;
    //-------------------------
    // invalid - for combatant
    //-------------------------
  } else if (
    !isValidCombatantReaction(parm.props.row["id"], parm.selected_reaction.name)
  ) {
    return false;
  }
  //------------
  // else valid
  //------------
  return true;
}
